import React from 'react';

const MessageListItem = ({ conversation, isActive, onClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Under Review':
      case 'Re-review':
        return 'bg-yellow-50 border-yellow-200 text-yellow-700';
      case 'Quote Pending':
        return 'bg-blue-50 border-blue-200 text-blue-700';
      case 'Approved':
        return 'bg-emerald-50 border-emerald-200 text-emerald-700';
      case 'Rejected':
        return 'bg-red-50 border-red-200 text-red-700';
      case 'Open':
        return 'bg-amber-50 border-amber-200 text-amber-700';
      case 'Answered':
        return 'bg-blue-50 border-blue-200 text-blue-700';
      case 'Closed':
        return 'bg-gray-50 border-gray-200 text-gray-700';
      case 'Direct':
      case 'Direct message':
        return 'bg-[#EBF9F3] border-[#40C191]/30 text-[#40C191]';
      default:
        return 'bg-gray-50 border-gray-200 text-gray-700';
    }
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${String(minutes).padStart(2, '0')} ${ampm}`;
  };

  return (
    <button
      onClick={() => onClick(conversation)}
      className={`w-full p-4 flex items-start gap-3 rounded-lg border transition-all text-left ${
        isActive
          ? 'bg-emerald-50 border-emerald-300 shadow-sm'
          : 'bg-white border-gray-200 hover:border-emerald-200 hover:bg-gray-50'
      }`}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-sm font-semibold text-gray-900 truncate">
            {conversation.isDirectMessage
              ? conversation.customerName || 'Customer'
              : conversation.licenceName || 'Unknown Licence'}
          </h3>
          <span className="text-xs text-gray-500 flex-shrink-0">
            {formatTime(conversation.lastMessage?.timestamp)}
          </span>
        </div>
        
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-1 min-w-0">
            <span className="text-xs text-gray-600 truncate">
              {conversation.isDirectMessage
                ? conversation.customerEmail || 'Direct message'
                : conversation.customerName || 'Unknown Customer'}
            </span>
          </div>
          
          {conversation.licenceStatus && (
            <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded-full border ${getStatusColor(conversation.licenceStatus)}`}>
              {conversation.licenceStatus}
            </span>
          )}
        </div>
        
        {conversation.lastMessage && (
          <p className="text-xs text-gray-500 truncate">
            {conversation.lastMessage.body}
          </p>
        )}

        {conversation.licenceRefNumber && (
          <div className="mt-1">
            <span className="text-[11px] font-bold text-gray-400 font-mono">
              Ref: {conversation.licenceRefNumber}
            </span>
          </div>
        )}
        
        {conversation.unreadCount > 0 && (
          <div className="mt-2 flex items-center gap-2">
            <span
              className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-white text-[10px] font-medium ${
                conversation.isSupportTicket ? 'bg-red-500' : 'bg-emerald-500'
              }`}
            >
              {conversation.unreadCount}
            </span>
            <span
              className={`text-xs font-medium ${
                conversation.isSupportTicket ? 'text-red-600' : 'text-emerald-600'
              }`}
            >
              Unread
            </span>
          </div>
        )}
      </div>
    </button>
  );
};

export default MessageListItem;






